<template>
  <div
    class="product__volumn-discount-base-on-tag"
    v-if="
      customVolumnDiscountBaseOnProductTag &&
      customVolumnDiscountBaseOnProductTag.html
    "
    v-html="customVolumnDiscountBaseOnProductTag.html"
  ></div>
  <template
    v-if="
      customVolumnDiscountBaseOnProductTag &&
      customVolumnDiscountBaseOnProductTag.html
    "
  >
    <input
      type="hidden"
      :name="`properties[_custom-volumn-discount]`"
      :value="customVolumnDiscountBaseOnProductTag.volumnDiscountProductTag"
    />
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'

interface VolumnDiscountBaseOnProductTag {
  volumnDiscountProductTag: string
  html: string
}

const productStore = useProductStore()
const settingStore = useSettingStore()

const volumnDiscountBaseOnProductTag = computed(
  () => settingStore.baseProductPage?.volumnDiscountBaseOnProductTag || []
)

const customVolumnDiscountBaseOnProductTag = computed(() => {
  const volumnDiscountTags = volumnDiscountBaseOnProductTag.value?.map(
    (item: VolumnDiscountBaseOnProductTag) => item.volumnDiscountProductTag
  )
  const customVolumnDiscountProductTag = productStore.product?.tags?.find(
    (tag) => volumnDiscountTags.includes(tag)
  )
  if (!customVolumnDiscountProductTag) return
  const customVolumnDiscount = volumnDiscountBaseOnProductTag.value?.find(
    (volumnDiscount: VolumnDiscountBaseOnProductTag) =>
      volumnDiscount.volumnDiscountProductTag == customVolumnDiscountProductTag
  )
  return customVolumnDiscount
})
</script>
